@if (loading) {
  <div>
    <div class="topics">
      <a class="topic biggest placeholder"></a>
      <a class="topic biggest placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
      <a class="topic placeholder"></a>
    </div>
  </div>
} @else {
  <div>
    <div class="mini-nav">
      <div class="menu">
        <a routerLink="/topics" routerLinkActive="active">
          <img src="/assets/icons-2019/topics.svg" />
          Topics
        </a>
      </div>
    </div>
    @for (category of categories; track category) {
      <div class="topics">
        @for (topic of topicsOfType(category.type); track topic; let i = $index) {
          <a routerLink="/topics/{{topic.slug}}" class="topic" [class.has-own-thumbnail]="topic.item.thumbnail"
            [responsiveBackgroundImage]="topic.thumbnail_square"
            [attr.data-shutter-order]="i"
            [class.biggest]="topic.featured">
            <div class="overlay"></div>
            <div class="gradient"></div>
            <div class="content-box">
              <div class="item">
                @if (topic.featured) {
                  <div class="star">
                    <mat-icon>star</mat-icon>
                  </div>
                }
                <div class="name">
                  {{topic.name}}
                </div>
                <div class="title">
                  {{topic.item.title | summarize}}
                </div>
                <div class="description">
                  {{ topic.description }}
                </div>
                <div class="show">
                  {{topic.item.date | date : 'MMMM d'}} | {{topic.item.brand_name}}
                </div>
              </div>
            </div>
          </a>
        }
      </div>
    }
  </div>
}
